import React from "react";

// Horizontal labeled percentage bar, e.g. response-score breakdown rows and
// the top-teams ranking bars.
export default function TspProgressBar({ label, value, percent, color = "#9F1D21" }) {
  return (
    <div className="tsp-progress-row">
      <span className="tsp-progress-label">{label}</span>
      <span className="tsp-progress-track">
        <span className="tsp-progress-fill" style={{ width: `${percent}%`, backgroundColor: color }} />
      </span>
      <span className="tsp-progress-value">{value}</span>
    </div>
  );
}
